module.exports = __webpack_public_path__ + "7e57e8d01e603006c0a44065959b3364.pdf";